export default __webpack_public_path__ + "static/linkedin-059e1f824bf6eb34cc723c076071c4bd.svg";